import React, { useState, useEffect }  from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import { Formik } from 'formik';
import * as Yup from "yup";

import { TailSpin } from 'react-loader-spinner';

const UpdatePasswordModal = ({ updatePasswordModal, handlePasswordModalHide, handleSubmitResetPassword, passwordLoading }) => {

    const initialValues = {
        currentPassword : '',
        newPassword : '',
        reenterPassword : ''
    };
    const resetPasswordSchema = Yup.object().shape({
        currentPassword : Yup.string()
            .required('Password is required')
            .min(8, "Password is too short - should be 8 chars minimum"),

        newPassword: Yup.string()
            .required("Password is required")
            .min(8, "Password is too short - should be 8 chars minimum"),

        reenterPassword: Yup.string()
            .required("Password is required")
            .oneOf([Yup.ref('newPassword'), null], 'Passwords must match')
    });

    return (
        <Modal
            // size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={updatePasswordModal}
            onHide={handlePasswordModalHide}
            className='profileModal'
        >
            <Formik
                initialValues={initialValues}
                validationSchema={resetPasswordSchema}
                onSubmit={handleSubmitResetPassword}
            >
                {({
                    values,
                    handleChange,
                    handleSubmit,
                    errors,
                    touched,
                    handleBlur,
                    isValid,
                    dirty
                }) => (
                    <Form noValidate onSubmit={handleSubmit}>
                        <Modal.Header closeButton>
                            <Modal.Title id="contained-modal-title-vcenter">
                                Update Password
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Form.Group className="mb-3" controlId="resetPasswordControl1">
                                <Form.Label>Current Password</Form.Label>
                                <Form.Control
                                    type="password"
                                    autoFocus
                                    required
                                    name="currentPassword"
                                    onChange={handleChange}
                                    value={values.currentPassword}
                                    isValid={touched.currentPassword && !errors.currentPassword}
                                    isInvalid={!!errors.currentPassword}
                                />
                                <Form.Control.Feedback type="invalid">{errors.currentPassword}</Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="resetPasswordControl2">
                                <Form.Label>New Password</Form.Label>
                                <Form.Control
                                    type="password"
                                    required
                                    name="newPassword"
                                    onChange={handleChange}
                                    value={values.newPassword}
                                    isValid={touched.newPassword && !errors.newPassword}
                                    isInvalid={!!errors.newPassword}
                                />
                                <Form.Control.Feedback type="invalid">{errors.newPassword}</Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="resetPasswordControl3">
                                <Form.Label>Re-enter New Password</Form.Label>
                                <Form.Control
                                    type="password"
                                    required
                                    name="reenterPassword"
                                    onChange={handleChange}
                                    value={values.reenterPassword}
                                    isValid={touched.reenterPassword && !errors.reenterPassword}
                                    isInvalid={!!errors.reenterPassword}
                                />
                                <Form.Control.Feedback type="invalid">{errors.reenterPassword}</Form.Control.Feedback>
                            </Form.Group>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button type="submit" className="d-flex justify-content-center">
                                Update &nbsp;
                                <TailSpin
                                    height="30"
                                    width="30"
                                    color="#ccc"
                                    ariaLabel="tail-spin-loading"
                                    radius="1"
                                    wrapperStyle={{}}
                                    wrapperClass="loader"
                                    visible={passwordLoading}
                                />
                            </Button>
                        </Modal.Footer>
                    </Form>
                )}
            </Formik>
        </Modal>
    );

}

export default UpdatePasswordModal;